<template>
  <div
    v-if="oidcUser"
    class="aco-grid"
  >
    <div class="aco-info-box">
      <quick-links/>
    </div>
    <div class="aco-details-box">
      <quick-searches/>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import QuickLinks from './QuickLinks'
  import QuickSearches from './QuickSearches'

  export default {
    name: 'home',
    components: {
      quickLinks: QuickLinks,
      quickSearches: QuickSearches
    },
    computed: {
      ...mapGetters('oidcStore', ['oidcUser']),
    },
  }
</script>
